module.exports = "<!-- Place all UI elements intended to be present across all routes in this file -->\n<app-header ng-if=\"vm.showHeader\"></app-header>\n\n<progress-bar states=\"vm.progressbarStates\"></progress-bar>\n\n<!-- used that when state changes user can navigate by tabs from start of page-->\n<a tabindex=\"0\" id=\"firstTabableElement\"></a>\n\n<!-- App content -->\n<div class=\"app-body fade-in\">\n  <div class=\"app-content\" ui-view autoscroll=\"false\"></div>\n</div>\n\n<!-- App footer -->\n<app-footer></app-footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.html
// module id = 1572
// module chunks = 0